import { v4 as uuid } from 'uuid';
import { isNumberGreaterThanZero, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";

class OrderShippingLine {
    id = uuid();
    methodTitle = null;
    methodId = null;
    taxStatus = "NONE";
    subtotal = 0.0;
    tax = 0.0;
    total = 0.0;

    constructor(orderShippingLine) {
        if (isObjectNotEmpty(orderShippingLine)) {
            if (isStringNotEmpty(orderShippingLine.id)) { this.id = orderShippingLine.id; }
            if (isStringNotEmpty(orderShippingLine.methodTitle)) { this.methodTitle = orderShippingLine.methodTitle; }
            if (isStringNotEmpty(orderShippingLine.methodId)) { this.methodId = orderShippingLine.methodId; }
            if (isStringNotEmpty(orderShippingLine.taxStatus)) { this.taxStatus = orderShippingLine.taxStatus; }
            if (isNumberGreaterThanZero(orderShippingLine.subtotal)) { this.subtotal = orderShippingLine.subtotal; }
            if (isNumberGreaterThanZero(orderShippingLine.tax)) { this.tax = orderShippingLine.tax; }
            if (isNumberGreaterThanZero(orderShippingLine.total)) { this.total = orderShippingLine.total; }
        }
    }

    toDto = () => {
        return {
            id: this.id,
            methodTitle: this.methodTitle,
            methodId: this.methodId,
            taxStatus: this.taxStatus,
            subtotal: this.subtotal,
            tax: this.tax,
            total: this.total,
        };
    }
};

export default OrderShippingLine;